import FlowHeader from '../../../components/FlowHeader/FlowHeader';
import FooterSite from '../../../components/FooterSite/FooterSite';
import BaseLayout from '../../../components/BaseLayout/BaseLayout';
import InternalAuthenticator from '../../../components/BaseLayout/InternalAuthenticator';
import SummitRewards from '../../../components/BaseLayout/SummitRewards';
import AddressValidationModal from '../../../components/AddressValidationModal/AddressValidationModal';
import CredentialsValidationModal from '../../../components/CredentialsValidationModal/CredentialsValidationModal';
import FONASUMFTransferScreen from '../../../screens/FONASUMFTransferScreen/FONASUMFTransferScreen';
import { FlowNode } from '../../../core/types/flow';
import { contactTextFn, updateFONASUAnalytics } from '../../shared/utils';
import { finish, openModal } from '../../../core/actions';
import { ToFromIRATypes } from '../../transfer-flows/loaders';
import {
  isAlphanumeric,
  usernameValidation,
  isValidSSN,
  isValidDob,
  meetsMinimumInvestment,
  isUsernameAlreadyTaken,
  isUsernameCreationFailed,
  isTempPasswordCreationFailed,
  chosenAddressValidation
} from '../../shared/testers';
import { makeLoadtransferData } from './loaders';
import { createFONASUApplication } from '../shared/loaders';

export const makeNodes = (toFromIRATypes: ToFromIRATypes): Array<FlowNode> => [
  {
    route: 'fonasuTransfer',
    screen: FONASUMFTransferScreen,
    load: makeLoadtransferData(toFromIRATypes),
    commit: createFONASUApplication,
    form: [
      { name: 'firstName', required: true },
      { name: 'lastName', required: true },
      { name: 'middleName' },
      { name: 'dob', required: true, validation: isValidDob },
      { name: 'citizenship', required: true },
      { name: 'ssn', required: true, validation: isValidSSN },
      { name: 'amount', required: true, validation: meetsMinimumInvestment },
      { name: 'residentialStreet1', required: true },
      { name: 'residentialStreet2' },
      { name: 'residentialZip', required: true },
      { name: 'residentialCity', required: true },
      { name: 'residentialState', required: true },
      { name: 'mailingStreet1', required: true },
      { name: 'mailingStreet2' },
      { name: 'mailingZip', required: true },
      { name: 'mailingCity', required: true },
      { name: 'mailingState', required: true },
      { name: 'primaryEmailAddress', required: true },
      { name: 'phone1' },
      { name: 'phone2' },
      { name: 'phone3' },
      { name: 'mailingAddressDifferent', type: 'checkbox' },
      { name: 'useResidentialAddress', required: true },
      { name: 'useMailingAddress', required: true },
      { name: 'manualProviderName', required: true },
      { name: 'assetsInBrokerage' },
      { name: 'cashAssets' },
      { name: 'accountName', required: true },
      { name: 'accountNumber', required: true, validation: isAlphanumeric },
      { name: 'transferBalance', required: true },
      { name: 'transferAmount', required: true },
      {
        name: 'username',
        validation: usernameValidation
      },
      {
        name: 'password'
      },
      { name: 'custodianBranchAddressStreet1', required: true },
      { name: 'custodianBranchAddressStreet2' },
      { name: 'custodianBranchZip', required: true },
      { name: 'custodianBranchCity', required: true },
      { name: 'custodianBranchState', required: true }
    ],
    next: {
      cases: [
        [chosenAddressValidation, openModal(AddressValidationModal)],
        [isUsernameAlreadyTaken, openModal(CredentialsValidationModal)],
        [isTempPasswordCreationFailed, openModal(CredentialsValidationModal)],
        [isUsernameCreationFailed, openModal(CredentialsValidationModal)]
      ],
      default: finish()
    },
    flowProps: {
      analytics: {
        pageName: 'FONASUTransfer'
      }
    }
  }
];

export const makeFlow = (path: string, toFromIRATypes: ToFromIRATypes): any => {
  const nodes = makeNodes(toFromIRATypes);
  return {
    namespace: `front-office/mutual-fund/transfer/${path}`,
    nodes,
    start: 'fonasuTransfer',
    pageDecorators: [BaseLayout, InternalAuthenticator, SummitRewards],
    onLoad: updateFONASUAnalytics,
    flowProps: {
      getContactText: contactTextFn(),
      header: FlowHeader,
      footer: FooterSite
    }
  };
};
